<template>
  <div>
    <canvas ref="carGraph" width="400" height="100"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import webservices from '@/utils/webservice'
import moment from 'moment'
import Strings from '@/utils/Strings'
export default {
  name: 'GraphComponent',

  props: ['dates', 'car'],

  data: () => ({
    carData: [],
    modelData: [],
    maxData: [],
    events: []
  }),

  mounted () {
    /**
    let icRefresh = new Image()
    icRefresh.src = 'https://multipublicador.grupomontalt.com/public/ic_refresh.png'
    events: [null, null, null, {
      icon: icRefresh,
      footer: `Cambiaste el precio de este vehículo`
    }, null, null, null],
      **/
    webservices.analytics.visualizationsFromDatesAndCar(this.car.id, this.dates).then(result => {
      let icChange = new Image()
      icChange.src = 'https://multipublicador.grupomontalt.com/public/ic_event.png'
      let icSold = new Image()
      icSold.src = 'https://multipublicador.grupomontalt.com/public/ic_sold.png'

      let icons = {
        generic: icChange,
        sold: icSold
      }

      if (result !== null) {
        let modelData = result.data[0]
        let carData = result.data[1]
        let maxData = result.data[2]
        this.events = this.dates.map(date => {
          let eventEntry = null
          for (let k in result.events) {
            if (result.events.hasOwnProperty(k)) {
              let event = result.events[k]
              if (event.timestamp === date) {
                eventEntry = this.getEventEntryForEvent(event, eventEntry, icons)
                // if (eventEntry === null) {
                //   eventEntry = {
                //     icon: icRefresh,
                //     footer: event.actionId,
                //     actions: []
                //   }
                // } else {
                //   eventEntry.footer += `\n ${event.actionId}`
                // }
              }
            }
          }
          return eventEntry
        })

        let labels = this.dates.map(date => moment(date * 1000).format(`D MMM`))
        this.loadGraph(this.$refs['carGraph'], labels, carData, modelData, maxData)
        this.$emit('graphDataReceived', result)
      }
    })
  },

  methods: {

    getEventEntryForEvent (event, eventEntry, icons) {
      console.log({timestamp: event.timestamp})
      if (eventEntry === null) {
        eventEntry = {
          icon: this.getIconForEvent(event, icons),
          footer: `${this.getEventActionDescriptionForEvent(event)} ${moment(event.rawTimestamp * 1000).format('HH:mm')}`
        }
      } else {
        eventEntry.footer += `\n ${this.getEventActionDescriptionForEvent(event)} ${moment(event.rawTimestamp * 1000).format('HH:mm')}`
      }
      return eventEntry
    },

    getIconForEvent (event, icons) {
      if (event.actionId === 'SOLD') {
        return icons.sold
      } else {
        return icons.generic
      }
    },

    getEventActionDescriptionForEvent: (event) => {
      switch (event.actionId) {
        case 'CREATE_VEHICLE':
          return 'Alta de vehículo '
        case 'DELETE_RESERVE':
          return 'Se ha quitado la reserva'
        case 'PUBLISH':
          return 'Se ha publicado'
        case 'RESERVE':
          return 'Se ha reservado'
        case 'SOLD':
          return 'Se ha vendido'
        case 'UNPUBLISH':
          return 'Se ha despublicado'
        case 'UPDATE_VEHICLE':
          return 'Se ha actualizado'
      }
    },

    loadGraph (carGraph, dates, carData, modelData, maxData) {
      let icRefresh = new Image()
      icRefresh.src = 'https://multipublicador.grupomontalt.com/public/ic_refresh.png'
      return new Chart(carGraph, {
        type: 'line',
        data: {
          labels: dates,
          datasets: [{
            label: 'Visitas de este vehículo',
            backgroundColor: 'rgba(60,141,188,0.9)',
            borderColor: 'rgba(60,141,188,0.8)',
            events: this.events,
            data: carData,
            fill: true
          }, {
            label: `Visitas de ${Strings.convertCase(this.car.version.maker.name)} ${Strings.convertCase(this.car.version.model.name)}`,
            backgroundColor: 'rgb(210, 214, 222)',
            borderColor: 'rgb(210, 214, 222)',
            data: modelData,
            fill: true
          }]
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: `${this.car.fullText} ${this.car.price.toLocaleString()} € ${this.car.plate}`
          },
          tooltips: {
            position: 'nearest',
            mode: 'index',
            intersect: false,
            callbacks: {
              // Use the footer callback to display the sum of the items showing in the tooltip
              footer: (tooltipItems, data) => {
                let footer = ``
                if (data.hasOwnProperty('datasets') && data.datasets instanceof Array) {
                  data.datasets.forEach((dataset, datasetIndex) => {
                    if (dataset.hasOwnProperty('events') && dataset.events instanceof Array) {
                      let tooltipIndex = tooltipItems[datasetIndex].index
                      if (dataset.events[tooltipIndex] !== null && dataset.events[tooltipIndex].hasOwnProperty('footer')) {
                        footer += `\n ${dataset.events[tooltipIndex].footer}`
                      }
                    }
                  })
                }

                return footer !== '' ? `\nInfo: ${footer}` : ''
              }
            },
            footerFontStyle: 'Helvetica Neue'
          },
          hover: {
            mode: 'index',
            intersect: true
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GraphComponent.vue